var classes = {
  "root": "m_f3f1af94",
  "inner": "m_89c4f5e4",
  "icon": "m_f3ed6b2b",
  "radio": "m_8a3dbb89",
  "radio--outline": "m_1bfe9d39"
};
export { classes as default };